import {EventEmitter, Injectable} from '@angular/core';

/*
  Generated class for the EventEmitterProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class EventEmitterProvider {

  private emitters: {
    [eventName: string]: EventEmitter<any>
  } = {};

  constructor() {
    console.log('Hello EventEmitterProvider Provider');
  }

  get(eventName: string): EventEmitter<any> {
    if (!this.emitters[eventName]) {
      this.emitters[eventName] = new EventEmitter<any>();
    }

    return this.emitters[eventName];
  }

}



// WEBPACK FOOTER //
// ./src/providers/event-emitter/event-emitter.ts